export default __webpack_public_path__ + "static/domea-2-497363e62cf5b2b3ff1bdafdc95ff70c.jpg";